<div *ngIf="!modalData.isEdit" [formGroup]="mostLeastForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
      <span *ngIf="mostLeastForm.value.media?.file_name">
        <span style="display: inline;">
          {{ mostLeastForm.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(mostLeastForm)">
          <span class="text-danger">✖</span>
        </button>
      </span>
      <!-- <span *ngIf="mostLeastForm.value.media?.file_name">{{ mostLeastForm.value.media.file_name }}</span> -->
    </div>
    <div class="col-1">
      <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\' ../../../../assets/multimedia.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
          (change)="addQuestionMedia($event, mostLeastForm)" style="display:none;" />
      </button>
    </div>
  </div>
  <div
    *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
    class="form-group row" formGroupName="media">
    <label class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
    <div class="col-2">
      <input [attr.disabled]="mostLeastForm.value.media.unlimit ? true : null" class="form-control"
        formControlName="time_again" type="number" min="0" width="100px" (change)="setTimeAgain(mostLeastForm, $event)">
    </div>
    <div class="col">
      <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
        (click)="clearValueDate(mostLeastForm)">
        ไม่จำกัดรอบ</mat-checkbox>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-2 col-form-label">ชื่อ Most<lifedi-require></lifedi-require></label>
    <div class="col-4">
      <input type="text" class="form-control" id="most" formControlName="most" autocomplete="off" ngDefaultControl>
    </div>
    <label class="col-2 col-form-label">ชื่อ Least<lifedi-require></lifedi-require></label>
    <div class="col-4">
      <input type="text" class="form-control" id="least" formControlName="least" autocomplete="off" ngDefaultControl>
    </div>
  </div>

  <div *ngFor="let c of mostLeastFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
      <input class="form-control col-10" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(mostLeastFormArray, i)"
        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
      </button>
      <div class="offset-1 col-11">{{ c.value.choiceImg }}</div>
    </div>
  </div>

  <button mat-mini-fab class="img col-1" (click)="addChoice(mostLeastFormArray)"
    [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
  </button>
</div>


<div *ngIf="modalData.isEdit" [formGroup]="mostLeastForm" class="mt-1">
  <div class="form-group row">
    <label class="col-2 col-form-label">คำถาม<lifedi-require></lifedi-require></label>
    <div class="col-9">
      <input type="text" class="form-control" id="question" formControlName="question" autocomplete="off"
        ngDefaultControl>
      <span *ngIf="mostLeastForm.value.media?.file_name">
        <span style="display: inline;">
          {{ mostLeastForm.value.media.file_name }}
        </span>
        <button mat-icon-button style="display: inline;" (click)="deleteImgQuestion(mostLeastForm)">
          <span class="text-danger">✖</span>
        </button>
      </span>
      <!-- <span *ngIf="mostLeastForm.value.media?.file_name">{{ mostLeastForm.value.media.file_name }}</span> -->
    </div>
    <div class="col-1">
      <button mat-mini-fab class="img" (click)="fileInput.click()" style="border-radius: 0; box-shadow: none;"
        [style.backgroundImage]="'url(\' ../../../../assets/multimedia.png\')'">
        <input #fileInput type="file" accept=".png, .jpg, .jpeg, .mp4, .mp3, .wav"
          (change)="addQuestionMedia($event, mostLeastForm)" style="display:none;" />
      </button>
    </div>
  </div>

  <div
    *ngIf="questionMediaType === 'mp4' || questionMediaType === 'mp3' || questionMediaType === 'wav' || questionMediaType === 'vdo' || questionMediaType === 'sound'"
    class="form-group row" formGroupName="media">
    <label class="col-6 col-form-label">จำนวนรอบที่วิดีโอ/เสียงสามารถเปิดซ้ำได้<lifedi-require></lifedi-require></label>
    <div class="col-2">
      <input [attr.disabled]="mostLeastForm.value.media.unlimit ? true : null" class="form-control"
        formControlName="time_again" type="number" min="0" width="100px" (change)="setTimeAgain(mostLeastForm, $event)">
    </div>
    <div class="col">
      <mat-checkbox id="unlimit" class="col-form-label" color="primary" formControlName="unlimit"
        (click)="clearValueDate(mostLeastForm)">
        ไม่จำกัดรอบ</mat-checkbox>
    </div>
  </div>

  <div class="form-group row">
    <label class="col-2 col-form-label">ชื่อ Most<lifedi-require></lifedi-require></label>
    <div class="col-4">
      <input type="text" class="form-control" id="most" formControlName="most" autocomplete="off" ngDefaultControl>
    </div>
    <label class="col-2 col-form-label">ชื่อ Least<lifedi-require></lifedi-require></label>
    <div class="col-4">
      <input type="text" class="form-control" id="least" formControlName="least" autocomplete="off" ngDefaultControl>
    </div>
  </div>


  <div *ngFor="let c of mostLeastFormArray.controls; let i = index" formArrayName="choices">
    <div [formGroupName]="i" class="form-group row">
      <label class="col-1 col-form-label">C{{i+1}}<lifedi-require></lifedi-require></label>
      <input class="form-control col-10" formControlName="choice_detail" type="text">
      <button mat-mini-fab class="img col-1" (click)="deleteChoice(mostLeastFormArray, i)"
        [style.backgroundImage]="'url(\' ../../../../assets/remove.png\')'">
      </button>
      <div class="offset-1 col-11">{{ c.value.choiceImg }}</div>
    </div>
  </div>

  <button mat-mini-fab class="img col-1" (click)="addChoice(mostLeastFormArray)"
    [style.backgroundImage]="'url(\' ../../../../assets/add.png\')'">
  </button>
</div>
